<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NKlgrG/tc-custom/9781685507923.jpg?1723403959354" alt="This image is the cover for the book 14 Beats—No Breath"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">14 Beats—No Breath
      </h1>
      <p class="bookDescription body article font2">
        <p>Cecil, son of Anna and Dr. Albert Morgan, was raised in a well-to-do neighborhood in the 1930s. Always feeling different -- separate -- from everyone around him, after college, he relocates to an Appalachian Mountain cabin.<br/><br/>Lonely at first, Cecil spends a great deal of time talking to himself. One night, he hears a song on a breeze with a long note held for fourteen beats. As far as Cecil knows, he is alone on that side of the desolate mountain, so who is singing?<br/><br/>He eventually meets up with the mysterious mountain man without a name, a man who also lives separated from the world. Was his seclusion a choice? When illness occurs, will the aid Cecil brings during a time when doctors treat mental illness like a crime and homosexuality as a mental illness make things better or worse?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Connor, E.F. Mulder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bee65fda